import react from "react";
import Wallpaper from "../../../src/assets/Whitepaper.png";
export default function Gs() {
  return (
    <>
      <div className="grid gap-4 grid-cols-2">
        <div className="p-10">
          <img src={Wallpaper} className="w-80" />
          <div className="text-whitepage text-2xl pt-2 pb-2">Getting started with Melody AI</div>
          <div className="text-whitepage text-base ">
            Lorem ipsum dolor sit amet consectetur. Tristique in duis pretium et
            eget ut maecenas dignissim at. Est lectus pretium id velit.
            Scelerisque ultrices fermentum auctor velit quis bibendum vestibulum
            platea arcu. Sit dignissim quam arcu at habitasse tristique
            ullamcorper aliquet. Lorem ipsum dolor sit amet consectetur.
            Tristique in duis pretium et eget ut maecenas dignissim at. Est
            lectus pretium id velit. Scelerisque ultrices fermentum auctor velit
            quis bibendum vestibulum platea arcu. Sit dignissim quam arcu at
            habitasse tristique ullamcorper aliquet.
          </div>
        </div>
        <div className="p-10">
          <img src={Wallpaper} className="w-80" />
          <div className="text-whitepage text-2xl pt-2 pb-2">Introduction to Melody AI</div>
          <div className="text-whitepage text-base ">
            Lorem ipsum dolor sit amet consectetur. Tristique in duis pretium et
            eget ut maecenas dignissim at. Est lectus pretium id velit.
            Scelerisque ultrices fermentum auctor velit quis bibendum vestibulum
            platea arcu. Sit dignissim quam arcu at habitasse tristique
            ullamcorper aliquet. Lorem ipsum dolor sit amet consectetur.
            Tristique in duis pretium et eget ut maecenas dignissim at. Est
            lectus pretium id velit. Scelerisque ultrices fermentum auctor velit
            quis bibendum vestibulum platea arcu. Sit dignissim quam arcu at
            habitasse tristique ullamcorper aliquet.
          </div>
        </div>
        <div className="p-10">
          <img src={Wallpaper} className="w-80" />
          <div className="text-whitepage text-2xl pt-2 pb-2">Getting started with no-code AI</div>
          <div className="text-whitepage text-base ">
            Lorem ipsum dolor sit amet consectetur. Tristique in duis pretium et
            eget ut maecenas dignissim at. Est lectus pretium id velit.
            Scelerisque ultrices fermentum auctor velit quis bibendum vestibulum
            platea arcu. Sit dignissim quam arcu at habitasse tristique
            ullamcorper aliquet. Lorem ipsum dolor sit amet consectetur.
            Tristique in duis pretium et eget ut maecenas dignissim at. Est
            lectus pretium id velit. Scelerisque ultrices fermentum auctor velit
            quis bibendum vestibulum platea arcu. Sit dignissim quam arcu at
            habitasse tristique ullamcorper aliquet.
          </div>
        </div>
        <div className="p-10">
          <img src={Wallpaper} className="w-80" />
          <div className="text-whitepage text-2xl pt-2 pb-2">Getting started</div>
          <div className="text-whitepage text-base ">
            Lorem ipsum dolor sit amet consectetur. Tristique in duis pretium et
            eget ut maecenas dignissim at. Est lectus pretium id velit.
            Scelerisque ultrices fermentum auctor velit quis bibendum vestibulum
            platea arcu. Sit dignissim quam arcu at habitasse tristique
            ullamcorper aliquet. Lorem ipsum dolor sit amet consectetur.
            Tristique in duis pretium et eget ut maecenas dignissim at. Est
            lectus pretium id velit. Scelerisque ultrices fermentum auctor velit
            quis bibendum vestibulum platea arcu. Sit dignissim quam arcu at
            habitasse tristique ullamcorper aliquet.
          </div>
        </div>
      </div>
    </>
  );
}
